const ConfirmationScreenDetails = () => {
  return null
}

ConfirmationScreenDetails.confirmButtonLabel = "Complete Transaction"

export default ConfirmationScreenDetails
